import {Log} from '@aboutyou/mlm';
import {ensureGlobalThis} from './globalThis';

const polyfills = {
  url: {
    // @see https://github.com/Financial-Times/polyfill-library/blob/master/polyfills/URL/detect.js
    shouldPolyfill() {
      try {
        const nativeURL = new globalThis.URL('http://example.com');
        if ('href' in nativeURL && 'searchParams' in nativeURL) {
          const url = new URL('http://example.com');
          url.search = 'a=1&b=2';
          if (url.href === 'http://example.com/?a=1&b=2') {
            url.search = '';
            // @ts-expect-error the value should mutate after removing search
            if (url.href === 'http://example.com/') {
              const sp1 = new globalThis.URLSearchParams('a=1');
              const sp2 = new globalThis.URLSearchParams(sp1);
              if (String(sp2) === 'a=1') {
                return false;
              }
            }
          }
        }
        return true;
      } catch (error) {
        return true;
      }
    },
    load() {
      // @ts-ignore
      return import('core-js/web/url');
    },
  },
  urlSearchParams: {
    // @see https://github.com/WebReflection/url-search-params#ios-10--other-platforms-bug
    shouldPolyfill() {
      try {
        if (new URLSearchParams('q=%2B').get('q') !== '+') throw new Error();
      } catch (error) {
        return true;
      }

      return false;
    },
    load() {
      // @ts-ignore
      return import('core-js/web/url-search-params');
    },
  },
  globalThis: {
    shouldPolyfill() {
      // global this polyfill is to small to fetch on demand
      return true;
    },
    load() {
      ensureGlobalThis();
    },
  },
  intersectionObserver: {
    shouldPolyfill() {
      // inspired by https://github.com/w3c/IntersectionObserver/blob/main/polyfill/intersection-observer.js#L19
      return (
        !('IntersectionObserver' in window) ||
        !('IntersectionObserverEntry' in window) ||
        !('intersectionRatio' in window.IntersectionObserverEntry.prototype) ||
        !('isIntersecting' in window.IntersectionObserverEntry.prototype)
      );
    },

    load() {
      // @ts-ignore
      return import('intersection-observer');
    },
  },
  fromEntries: {
    shouldPolyfill() {
      try {
        return !('fromEntries' in Object);
      } catch (error) {
        return true;
      }
    },
    load() {
      // @ts-ignore
      return import('core-js/features/object/from-entries');
    },
  },
  flat: {
    shouldPolyfill() {
      try {
        return !('flat' in Array.prototype);
      } catch (error) {
        return true;
      }
    },
    load() {
      // @ts-ignore
      return import('core-js/features/array/flat');
    },
  },
  at: {
    shouldPolyfill() {
      try {
        return !('at' in Array.prototype);
      } catch (error) {
        return true;
      }
    },
    load() {
      // @ts-ignore
      return import('core-js/features/array/at');
    },
  },
  flatMap: {
    shouldPolyfill() {
      try {
        return !('flatMap' in Array.prototype);
      } catch (error) {
        return true;
      }
    },
    load() {
      // @ts-ignore
      return import('core-js/features/array/flat-map');
    },
  },
};

export function ensurePolyfillsLoaded() {
  const polyfillKeys = Object.keys(polyfills) as Array<keyof typeof polyfills>;

  return Promise.all(
    polyfillKeys.map(polyfill => {
      const {shouldPolyfill, load} = polyfills[polyfill];

      if (shouldPolyfill()) {
        if (process.env.NODE_ENV !== 'production') {
          Log.warn('@aboutyou/bootstrap', `Loading polyfill' ${polyfill}`);
        }
        return load();
      }

      return undefined;
    }),
  );
}
